module.exports = __webpack_public_path__ + "static/img/xxdt.c1db9d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/linshi/xxdt.png
// module id = s0UC
// module chunks = 44